<template>
  <div class="card mb-2 total-cart-amount">
    <div class="card-body">
      <div class="cart-total">
        <!-- <div class="row mb-1" v-for="cartInformation in cartInformations">
                        <div class="col light"><p>{{cartInformation.label}}</p></div>
                        <div class="col text-right"><p>{{cartInformation.Item}}</p></div>
        </div>-->
        <div
          v-for="(item, index) in this.state.billing.billing.cart.bill_summary"
          :key="index"
        >
          <div class="row mb-1">
            <div class="col light">
              <p class="t_amt d-lfex">
                <!-- <img
                  src="@/assets/images/remove-discount.svg"
                  alt="Remove Manual Discount"
                  @click="removeDiscount"
                  v-if="item.display_text == 'Manual Discount'"
                />-->
                {{ item.display_text }}
                <img
                  src="@/assets/images/icon_info.svg"
                  v-b-tooltip.click.bottomLeft.html="discountData"
                  alt
                  class
                  v-if="item.display_text == 'Manual Discount'"
                />
              </p>
            </div>
            <div class="col text-right">
              <p>
                {{ item.sign != "" ? item.sign : "" }} {{ currencySymbol }}
                {{ formatAmount(item.value) }}
              </p>
            </div>
          </div>

          <!--<div class="row mb-1">
          <div class="col light">
            <p>Carry Bags</p>
          </div>
          <div class="col text-right">
            <p>₹ {{ this.state.billing.cart.carry_bag_total }}</p>
          </div>
          </div>-->
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col light t_amt">
          <p>Payable Amount</p>
        </div>
        <div class="col text-right">
          <h6 class="mb-0">
            {{ currencySymbol }}
            {{ formatAmount(state.billing.billing.total_payable) }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import { mapState } from "vuex";
// import image from "../assets/images/remove-discount.svg";
// import * as msg from "../message";
export default {
  name: "cart-total",
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    discountData() {
      let item_level = "0.00";
      let bill_level = "0.00";
      let tipData = {};
      tipData.customClass = "custom-tooltip";

      this.state.billing.billing.cart.bill_summary.map((item) => {
        if (item.name == "manual_discount")
          item.type.map((type) => {
            if (type.name == "item_level")
              item_level = this.formatAmount(type.value);
            if (type.name == "bill_level")
              bill_level = this.formatAmount(type.value);
          });
      });

      tipData.title =
        "<div class='row fs-12 text-left mb-2' style='line-height: 16px;'><div class='col-7'>Total Item Manual Discount</div> <div class='col-5  text-right'><b>" +
        this.currencySymbol +
        item_level +
        "</b></div></div><div class='row fs-12 text-left' style='line-height: 16px;'><div class='col-7'>Bill Discount</div><div class='col-5 text-right'><b>" +
        this.currencySymbol +
        "</b><b>" +
        bill_level +
        "</b></div></div>";
      return tipData;
    },
  },
  methods: {
    /*removeDiscount() {
      this.$loading = true;
      let postData = {
        store_id: this.state.sessions.user.store_id,
        manual_discount_basis: "",
        remove_discount: "1",
        trans_from: this.state.system.trans_from,
        api_token: this.state.sessions.user.api_token,
        manual_discount_factor: "",
        url: "/manual-discount",
        cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
          "gstin"
        )
          ? this.state.billing.billing.customer.data.gstin
          : ""
      };

      let data = Object.assign(
        postData,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(data.url, data)
        .then(res => {
          this.$store.dispatch("billing/cartDetails").then(() => {
            this.$loading = false;

            let alertData = {
              message: msg.REMOVED_MANUAL_DISCOUNT,
              type: "success"
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          });
        })
        .catch(err => {
          this.$loading = false;
        });
    }*/
    // manualDiscount() {
    //   var cartTotal = document.querySelector(".cart-total");
    //   var textinp = cartTotal.getElementsByTagName("p");
    //   var removeimg = new Image();
    //   removeimg.src = "../assets/images/remove.svg";
    //   for (var i = 0; i < textinp.length; i++) {
    //     if (textinp[i].innerText == "Manual Discount") {
    //       // textinp[i].innerHTML = "<img src='../assets/images/remove.svg'>";
    //       textinp[i].prepend(removeimg);
    //     }
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
.cart-total {
  p img {
    cursor: pointer;
  }
}
</style>
